<template lang="pug" src="./html/PortfolioMenu.pug"></template>

<script>

    import ContentMenuBase from './../ContentMenuBase'

    // Portfolio Items
    import Overview from './Overview'
    import PortfolioAdidasSchnellerInsTrikot from './AdidasSchnellerInsTrikot'
    import PortfolioASOSUrbanTour from './ASOSUrbanTour'
    import PortfolioCadburyYouTubeDanceOff from './CadburyYouTubeDanceOff'
    import PortfolioCokeZeroTrustYourBuds from './CokeZeroTrustYourBuds'
    import PortfolioCOPPSusMakeover from './COPPSusMakeover'
    import PortfolioFordAutoshows from './FordAutoshows'
    import PortfolioGalaxyIDD from './GalaxyIDD'
    import PortfolioHKWD from './HKWD'
    import PortfolioLincolnVirtualCarConfig from './LincolnVirtualCarConfig'
    import PortfolioLondonWorkCampaignAR from './LondonWorkCampaignAR'
    import PortfolioMountFranklinWOP from './MountFranklinWOP'
    import PortfolioPacificPlaceIDD from './PacificPlaceIDD'
    import PortfolioPhilipsObsessedWithSound from './PhilipsObsessedWithSound'
    import PortfolioSNCFLesPetitsServices from './SNCFLesPetitsServices'
    import PortfolioTriumphYouAreWonderful from './TriumphYouAreWonderful'
    import PortfolioNikeNBAConnectedJersey from './NikeNBAConnectedJersey'
    import PortfolioNikeWeChatCampaigns from './NikeWeChatCampaigns'

    const COMPONENTS_LIST = []
    const COMPONENTS = {
      Overview,
      PortfolioLincolnVirtualCarConfig,
      PortfolioGalaxyIDD,
      PortfolioPacificPlaceIDD,
      PortfolioFordAutoshows,
      PortfolioLondonWorkCampaignAR,
      PortfolioHKWD,
      PortfolioASOSUrbanTour,
      PortfolioPhilipsObsessedWithSound,
      PortfolioSNCFLesPetitsServices,
      PortfolioAdidasSchnellerInsTrikot,
      PortfolioCadburyYouTubeDanceOff,
      PortfolioCOPPSusMakeover,
      PortfolioMountFranklinWOP,
      PortfolioTriumphYouAreWonderful,
      PortfolioCokeZeroTrustYourBuds,
      PortfolioNikeNBAConnectedJersey,
      PortfolioNikeWeChatCampaigns
    }
    for (let component in COMPONENTS) {
      COMPONENTS_LIST.push(COMPONENTS[component])
    }

    export default {
      extends: ContentMenuBase,
      components: COMPONENTS,
      name: 'PortfolioMenu',
      beforeCreate () {
        this.contentManager.init(COMPONENTS_LIST, 'PortfolioMenu')
      }
    }

</script>

<style lang="sass" src="./../../style/carousel-menu.sass"></style>
